import type { Role } from '@mollusk/shared';

export interface NavItem {
  label: string;
  /** In-app route… */
  to?: string;
  /** …or an external link (mailto:). */
  href?: string;
}

export const HELP_EMAIL = 'holly@mollusk.io';

/** Top-bar items by role (#171). Prospects never see the internal QA tools. */
export function navFor(role: Role): { main: NavItem[]; right: NavItem[]; admin: NavItem[] } {
  const main: NavItem[] = [
    { label: 'Search', to: '/search' },
    { label: 'Coverage', to: '/coverage' },
    { label: 'Explore', to: '/explore' },
    { label: 'Tags', to: '/tags' },
    { label: 'Sample data', to: '/sample-data' },
    { label: 'Data dictionary', to: '/data-dictionary' },
  ];
  const right: NavItem[] = [
    { label: 'Help', href: `mailto:${HELP_EMAIL}` },
    { label: 'Terms', to: '/terms' },
  ];
  if (role !== 'admin') return { main, right, admin: [] };
  return {
    main: [...main, { label: 'Activity', to: '/admin/activity' }],
    right,
    admin: [
      { label: 'Users', to: '/admin/users' },
      { label: 'Permit detail', to: '/permit-detail' },
      { label: 'P&Z detail', to: '/planning-detail' },
      { label: 'Contractor detail', to: '/contractor-detail' },
      { label: 'Parcel map', to: '/parcel-map' },
    ],
  };
}
